import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex align-right"
}

import { onMounted, ref, computed } from "vue";
import { useStore } from "@/store";
import { useRoute } from "vue-router";
import AccountService from "../../accounts/services/AccountService";
import { Actions } from "@/store/enums/StoreEnums";
import { AgentAccount } from "@/projects/client/modules/ib/store/IbModule";
import { FundTypes } from "@/core/types/FundTypes";
import { CurrencyTypes } from "@/core/types/CurrencyTypes";
import { isMobile } from "@/core/config/WindowConfig";

export default /*#__PURE__*/_defineComponent({
  __name: 'IBSelector',
  setup(__props) {

const store = useStore();
const route = useRoute();

const ibAccounts = ref(Array<AgentAccount>());
const ibAccountUids = ref(store.state.AuthModule.user.ibAccount);
const agentAccount = ref(store.state.AgentModule.agentAccount);
const defaultIbAccount = ref(store.state.AuthModule.user.defaultAgentAccount);

onMounted(async () => {
  const res = await AccountService.queryAccounts({
    uids: ibAccountUids.value,
  });

  ibAccounts.value = res.data.map(
    (x): AgentAccount => ({
      uid: x.uid,
      currencyId: x.currencyId as CurrencyTypes,
      fundType: x.fundType as FundTypes,
      role: x.role,
      type: x.type,
      name: x.name,
      siteId: x.siteId,
      hasLevelRule: x.hasLevelRule,
      salesGroupName: x.code,
      createdOn: x.createdOn,
      agentSelfGroupName: x.group,
      alias: x.alias,
    })
  );

  if (agentAccount.value?.uid) return;
  var ibCurrentAccount = ibAccounts.value[0];
  if (defaultIbAccount.value && defaultIbAccount.value !== "0") {
    ibCurrentAccount = ibAccounts.value.find(
      (x) => x.uid == defaultIbAccount.value
    );
  }

  await store.dispatch(Actions.PUT_IB_ACCOUNTS, ibAccounts.value);
  await store.dispatch(Actions.PUT_IB_CURRENT_ACCOUNT, ibCurrentAccount);
  console.log("");
});

const showIbSelector = computed(() => 1 || /^\/ib/.test(route.path));

return (_ctx: any,_cache: any) => {
  return (showIbSelector.value && ibAccounts.value.length > 1 && !_unref(isMobile))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1))
    : _createCommentVNode("", true)
}
}

})